import React from 'react';
import PropTypes from 'prop-types';
import ModalContent from './ModalContent';

export class Modal extends React.Component {
  static _handleOnClickContent(e) {
    e.stopPropagation();
  }

  constructor(props) {
    super(props);

    this.state = {
      hide: true
    };
  }

  componentDidMount = () => {
    document.addEventListener('keydown', this._handleOnKeyPressed);
  };

  componentWillUnmount = () => {
    this.hide();
  };

  _handleOnKeyPressed = e => {
    const { hide } = this.state;
    const { allowClose } = this.props;

    if (!hide && allowClose && e.which === 27) {
      e.preventDefault();
      this.hide();
    }
  };

  show = () => {
    this.setState({ hide: false });
    if (document && document.body) {
      document.body.classList.add('pxl-modal-body');
    }
  };

  hide = () => {
    this.setState({ hide: true });
    if (document && document.body) {
      document.body.classList.remove('pxl-modal-body');
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  _handleOnClick = e => {
    if (this.props.allowClose) {
      this.hide();
    }
  };

  render() {
    const { className, children, id, displayCloseButton } = this.props;
    const { hide } = this.state;

    return (
      <div
        id={id}
        className={`${className} pxl-modal${hide ? ' pxl-modal--hidden' : ''}`}
        onClick={this._handleOnClick}
      >
        <ModalContent
          id={id}
          onIgnore={Modal._handleOnClickContent}
          onClose={this._handleOnClick}
          displayCloseButton={displayCloseButton}
        >
          {children}
        </ModalContent>
      </div>
    );
  }
}

Modal.propTypes = {
  allowClose: PropTypes.bool,
  className: PropTypes.string,
  displayCloseButton: PropTypes.bool,
  id: PropTypes.string,
  onClose: PropTypes.func
};

Modal.defaultProps = {
  allowClose: true,
  className: '',
  displayCloseButton: false,
  id: 'modal',
  onClose: undefined
};

export default Modal